import types from '../../mutation-types';

export const mutations = {
  [types.SET_CHAT_GROUP_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
};
